import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { bool, func } from 'prop-types';

const styles = (isPlaying, isPrimaryLight) => ({
  playContainer: {
    backgroundColor: 'primary',
    borderRadius: '50%',
    display: 'inline-block',
    height: 56,
    width: 56,
    cursor: 'pointer'
  },
  iconContainer: {
    position: 'relative',
    height: '100%',
    width: '100%'
  },
  icon: {
    position: 'absolute',
    color: isPrimaryLight ? '#000' : '#FFF',
    top: 0,
    bottom: 0,
    margin: 'auto',
    left: 0,
    right: 0
  },
  pause: {
    position: 'absolute',
    backgroundColor: 'primary',
    opacity: isPlaying ? 0.3 : 0,
    index: -1,
    borderRadius: '50%',
    height: 70,
    width: 70,
    top: -7,
    right: -7
  }
});

function PlayButton({ play, isPlaying, isPrimaryLight }) {
  const { playContainer, iconContainer, icon, pause } = styles(isPlaying, isPrimaryLight);
  const getTCCLString = UX2.utils.TCCLUtils.getTCCLString;

  return (
    <UX2.Element.Block
      style={ playContainer }
      onClick={ play }
      data-tccl={ getTCCLString({
        eid: isPlaying ? 'ux2.podcast.pause_button.click' : 'ux2.podcast.play_button.click',
        type: 'click'
      }) }
    >
      <UX2.Element.Block style={ iconContainer }>
        <UX2.Element.Block style={ pause } />
        <UX2.Element.Icon icon={ isPlaying ? 'pause' : 'play' } size='large' style={ icon } />
      </UX2.Element.Block>
    </UX2.Element.Block>
  );
}

PlayButton.propTypes = {
  play: func,
  isPlaying: bool,
  isPrimaryLight: bool
};

export default PlayButton;
